// extracted by mini-css-extract-plugin
export default {"customButton":"BankAccountCards_customButton__7z1zh","active":"BankAccountCards_active__3UCPo","groupcont":"BankAccountCards_groupcont__Qc+n9"};